module.exports = __webpack_public_path__ + "/static/assets/8beb9da10f72d02b48baf0b24ac72449.svg";